(function () {
    'use strict';

    angular
        .module('tikonApp')
        .controller('CompanyCustomerListController', CompanyCustomerListController);

    CompanyCustomerListController.$inject = ['$scope', '$state', 'ParseLinks', 'AlertService', 'CompanyCustomerCustom', 'pagingParams', 'paginationConstants', '$mdDialog'];

    function CompanyCustomerListController($scope, $state, ParseLinks, AlertService, CompanyCustomerCustom, pagingParams, paginationConstants, $mdDialog) {
        var vm = this;

        vm.loadPage = loadPage;
        vm.transition = transition;
        vm.clear = clear;
        vm.gotoNewReserve = gotoNewReserve;

        vm.predicate = pagingParams.predicate;
        vm.reverse = pagingParams.ascending;
        vm.search = search;
        vm.searchQuery = pagingParams.search;
        vm.currentSearch = pagingParams.search;
        vm.searchKeyPress = searchKeyPress;


        loadAll_paging();

        function loadAll_paging() {

            if (pagingParams.search) {
                CompanyCustomerCustom.getAllCompanyCustomers().query({
                    query: pagingParams.search,
                    page: pagingParams.page - 1,
                    size: paginationConstants.itemsPerPage,
                    sort: sort()
                }, onSuccess, onError);
            } else {
                CompanyCustomerCustom.getAllCompanyCustomers().query({
                    query: "",
                    page: pagingParams.page - 1,
                    size: paginationConstants.itemsPerPage,
                    sort: sort()
                }, onSuccess, onError);
            }

            function sort() {
                var result = [vm.predicate + ',' + (vm.reverse ? 'asc' : 'desc')];
                if (vm.predicate !== 'id') {
                    result.push('id');
                }
                return result;
            }

            function onSuccess(data, headers) {
                vm.links = ParseLinks.parse(headers('link'));
                vm.totalItems = headers('X-Total-Count');
                vm.queryCount = vm.totalItems;
                vm.companyCustomers = data;
                vm.page = pagingParams.page;
            }

            function onError(error) {
                AlertService.error(error.data.message);
            }
        }

        function loadPage(page) {
            vm.page = page;
            vm.transition();
        }

        function transition() {
            $state.transitionTo($state.$current, {
                page: vm.page,
                sort: vm.predicate + ',' + (vm.reverse ? 'asc' : 'desc'),
                search: vm.currentSearch
            });
        }


        function clear() {
            vm.links = null;
            vm.page = 1;
            vm.predicate = 'id';
            vm.reverse = true;
            vm.currentSearch = null;
            vm.transition();
        }

        function gotoNewReserve(customerId) {


            $state.go('supplierPanel.reserveWithCustomerParameter', {
                customerId: customerId
            });


        }


        function search() {
            if (!vm.searchQuery) {
                return clear();
            }
            loadAll_paging();
            vm.links = null;
            vm.page = 1;
            vm.predicate = '_score';
            vm.reverse = false;
            vm.currentSearch = vm.searchQuery;
            vm.transition();
        }

        function clear() {
            vm.links = null;
            vm.page = 1;
            vm.predicate = 'id';
            vm.reverse = true;
            vm.currentSearch = null;
            vm.transition();
        }

        function searchKeyPress(keyEvent) {
            if (keyEvent.which === 13) {
                search();
            }
        }
    }
})();
